import styled from 'styled-components';

export const ImageContainer = styled.div`
  img {
    border-radius: 50%;
  }
`;
